
import React from "react"


const AmericanOdds = ({ val }) => {

    // display with positive and negative //
    let formattedOdds = val

    if (parseInt(val) < 0) {
        formattedOdds = '-' + Math.abs(val)
    } else {
        formattedOdds = '+' + Math.abs(val)
    }

    return (
        <div style={{
            display : 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '10px',
        }}>
            {formattedOdds}
        </div>
    )
    
}

export default AmericanOdds